export const Close = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="{1.5}"
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </svg>
);
export const QuestionIcon = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="{1.5}"
    stroke="currentColor"
    className="w-6 h-6"
    style={{ color: "var(--base)" }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
    />
  </svg>
);
export const EditIcon = () => (
  <svg
    width={19}
    height={20}
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.000105979 16.6266V5.93806C0.000105979 5.30821 0.250424 4.70401 0.695849 4.25858C1.14127 3.81305 1.74544 3.56284 2.37533 3.56284H9.63566L7.29996 5.93803H2.37526V16.6265H13.0638V11.7018L15.439 9.36613V16.6265C15.439 17.2563 15.1888 17.8605 14.7432 18.3059C14.2978 18.7514 13.6936 19.0017 13.0637 19.0017H2.37522C1.74536 19.0017 1.14117 18.7514 0.695742 18.3059C0.250317 17.8605 0 17.2564 0 16.6265L0.000105979 16.6266ZM17.2205 7.28097e-06C16.7483 0.000421496 16.2954 0.18847 15.9617 0.522592L7.52154 9.10521C7.26128 9.36933 7.06495 9.68964 6.9476 10.0414L6.09255 12.6146H6.09242C6.06411 12.7016 6.08717 12.7973 6.15179 12.8621C6.21654 12.9267 6.31222 12.9497 6.3992 12.9214L8.9724 12.0664V12.0662C9.32102 11.9438 9.63721 11.7434 9.89676 11.4804L18.4794 3.04025C18.8131 2.70626 19.0004 2.25339 19.0003 1.78121C19.0003 1.30902 18.8128 0.856282 18.4791 0.522302C18.1454 0.188314 17.6927 0.000396082 17.2205 7.28097e-06Z"
      fill="#9C9C9C"
      fillOpacity="0.56"
    />
  </svg>
);

export const Trash = () => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="{1.5}"
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
  </svg>
);
export const Logout = () => (
  <svg
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3576 5.7704H3.40424V7.419H11.3576L8.3961 10.3653L9.55626 11.5408L14.5023 6.59469L9.55626 1.64862L8.3961 2.8241L11.3576 5.7704Z"
      fill="white"
    />
    <path
      d="M4.80867 11.5408H1.64869V1.64869H4.80867V0H0V13.1895H4.80867V11.5408Z"
      fill="white"
    />
  </svg>
);
export const Send = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6"
  >
    <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
  </svg>
);
export const FaqsIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C3.14 0 0 3.14 0 7C0 10.8597 3.14 14 7 14C10.8597 14 14 10.8597 14 7C14 3.14 10.8597 0 7 0ZM7 12.5372C3.94667 12.5372 1.46278 10.0532 1.46278 7C1.46278 3.94683 3.94661 1.46278 7 1.46278C10.0534 1.46278 12.5372 3.94683 12.5372 7C12.5372 10.0532 10.0534 12.5372 7 12.5372Z"
      fill="white"
    />
    <path d="M6.26862 5.95526H7.73117V10.3433H6.26862V5.95526Z" fill="white" />
    <path d="M6.26862 3.65665H7.73117V4.91034H6.26862V3.65665Z" fill="white" />
  </svg>
);
export const Discord = () => (
  <svg
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8593 0.888625C10.9395 0.467511 9.96848 0.168759 8.97103 0C8.83453 0.244001 8.71103 0.495045 8.60104 0.752083C7.53856 0.591978 6.45809 0.591978 5.39561 0.752083C5.28556 0.495072 5.16206 0.24403 5.02562 0C4.02753 0.170184 3.05585 0.469646 2.13511 0.890827C0.307209 3.59524 -0.188307 6.23249 0.0594513 8.83229C1.12992 9.6232 2.32807 10.2247 3.60184 10.6106C3.88865 10.2249 4.14245 9.81565 4.36053 9.38727C3.94631 9.23257 3.54652 9.0417 3.16578 8.81688C3.26599 8.7442 3.36399 8.66932 3.45869 8.59665C4.56655 9.11765 5.77572 9.38778 6.99998 9.38778C8.22423 9.38778 9.4334 9.11765 10.5413 8.59665C10.6371 8.67483 10.7351 8.74971 10.8342 8.81688C10.4527 9.04206 10.0522 9.2333 9.63722 9.38837C9.85503 9.81655 10.1088 10.2254 10.3959 10.6106C11.6708 10.2262 12.8698 9.62503 13.9405 8.83339C14.2312 5.81846 13.4439 3.20544 11.8593 0.888625ZM4.67436 7.23343C3.98394 7.23343 3.41354 6.60688 3.41354 5.83607C3.41354 5.06527 3.96412 4.43321 4.67215 4.43321C5.38019 4.43321 5.94618 5.06527 5.93407 5.83607C5.92195 6.60688 5.37799 7.23343 4.67436 7.23343ZM9.3256 7.23343C8.63408 7.23343 8.06588 6.60688 8.06588 5.83607C8.06588 5.06527 8.61646 4.43321 9.3256 4.43321C10.0347 4.43321 10.5963 5.06527 10.5842 5.83607C10.5721 6.60688 10.0292 7.23343 9.3256 7.23343Z"
      fill="white"
    />
  </svg>
);
export const CreativeIcon = () => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2731 27.7607C14.4259 28.0605 13.8186 28.8692 13.8186 29.8181C13.8186 31.0225 14.7961 32 16.0005 32C17.2049 32 18.1824 31.0225 18.1824 29.8181C18.1824 28.8689 17.575 28.0603 16.7279 27.7607V22.5455C16.7279 22.1439 16.4021 21.8181 16.0005 21.8181C15.599 21.8181 15.2731 22.1439 15.2731 22.5455V27.7607ZM16.0005 30.5455C15.599 30.5455 15.2731 30.2197 15.2731 29.8181C15.2731 29.4166 15.599 29.0908 16.0005 29.0908C16.4021 29.0908 16.7279 29.4166 16.7279 29.8181C16.7279 30.2197 16.4021 30.5455 16.0005 30.5455ZM3.63685 21.9428C2.78967 22.2425 2.18236 23.0512 2.18236 24.0002C2.18236 25.2046 3.15983 26.182 4.36422 26.182C5.56861 26.182 6.54608 25.2046 6.54608 24.0002C6.54608 23.051 5.93876 22.2423 5.09159 21.9428V20.3638H10.1827C10.5842 20.3638 10.91 20.038 10.91 19.6365C10.91 19.2349 10.5842 18.9091 10.1827 18.9091H5.09159C4.28798 18.9091 3.6371 19.56 3.6371 20.3636V21.9425L3.63685 21.9428ZM26.9098 21.9428C26.0626 22.2425 25.4553 23.0512 25.4553 24.0002C25.4553 25.2046 26.4328 26.182 27.6372 26.182C28.8415 26.182 29.819 25.2046 29.819 24.0002C29.819 23.051 29.2117 22.2423 28.3645 21.9428V20.3638C28.3645 19.5602 27.7137 18.9094 26.91 18.9094H21.819C21.4174 18.9094 21.0916 19.2352 21.0916 19.6367C21.0916 20.0383 21.4174 20.3641 21.819 20.3641H26.91V21.943L26.9098 21.9428ZM4.36372 24.7276C3.96217 24.7276 3.63635 24.4017 3.63635 24.0002C3.63635 23.5986 3.96217 23.2728 4.36372 23.2728C4.76527 23.2728 5.09109 23.5986 5.09109 24.0002C5.09109 24.4017 4.76527 24.7276 4.36372 24.7276ZM27.6367 24.7276C27.2351 24.7276 26.9093 24.4017 26.9093 24.0002C26.9093 23.5986 27.2351 23.2728 27.6367 23.2728C28.0382 23.2728 28.364 23.5986 28.364 24.0002C28.364 24.4017 28.0382 24.7276 27.6367 24.7276ZM16.3739 11.013C16.144 10.8742 15.856 10.8742 15.6263 11.013L11.99 13.1949C11.7704 13.3259 11.6364 13.5628 11.6364 13.8183V18.182C11.6364 18.4372 11.7703 18.6744 11.99 18.8054L15.6263 20.9872C15.8562 21.126 16.1443 21.126 16.3739 20.9872L20.0103 18.8054C20.2299 18.6744 20.3638 18.4374 20.3638 18.182V13.8183C20.3638 13.5631 20.2299 13.3259 20.0103 13.1949L16.3739 11.013ZM16.0001 12.4843L18.9094 14.2298V17.7702L16.0001 19.5157L13.0909 17.7702V14.2298L16.0001 12.4843ZM4.23929 16.7272H10.1819C10.5835 16.7272 10.9093 16.4014 10.9093 15.9999C10.9093 15.5983 10.5835 15.2725 10.1819 15.2725H4.23929C3.93952 14.4253 3.13084 13.818 2.18186 13.818C0.977472 13.818 0 14.7955 0 15.9999C0 17.2043 0.977472 18.1817 2.18186 18.1817C3.13109 18.1817 3.93975 17.5744 4.23929 16.7272ZM27.761 15.2728H21.8183C21.4168 15.2728 21.091 15.5986 21.091 16.0001C21.091 16.4017 21.4168 16.7275 21.8183 16.7275H27.761C28.0607 17.5747 28.8694 18.182 29.8184 18.182C31.0228 18.182 32.0002 17.2045 32.0002 16.0001C32.0002 14.7957 31.0228 13.8183 29.8184 13.8183C28.8692 13.8183 28.0605 14.4256 27.761 15.2728ZM2.18148 15.2728C2.58303 15.2728 2.90885 15.5986 2.90885 16.0001C2.90885 16.4017 2.58303 16.7275 2.18148 16.7275C1.77993 16.7275 1.45411 16.4017 1.45411 16.0001C1.45411 15.5986 1.77993 15.2728 2.18148 15.2728ZM29.8181 15.2728C30.2197 15.2728 30.5455 15.5986 30.5455 16.0001C30.5455 16.4017 30.2197 16.7275 29.8181 16.7275C29.4166 16.7275 29.0908 16.4017 29.0908 16.0001C29.0908 15.5986 29.4166 15.2728 29.8181 15.2728ZM26.9089 10.0575V11.6364H21.8178C21.4163 11.6364 21.0905 11.9622 21.0905 12.3638C21.0905 12.7653 21.4163 13.0911 21.8178 13.0911H26.9089C27.7125 13.0911 28.3634 12.4403 28.3634 11.6367V10.0577C29.2106 9.75798 29.8179 8.9493 29.8179 8.00031C29.8179 6.79593 28.8404 5.81845 27.636 5.81845C26.4316 5.81845 25.4542 6.79593 25.4542 8.00031C25.4542 8.94954 26.0615 9.7582 26.9087 10.0577L26.9089 10.0575ZM3.63597 10.0575V11.6364C3.63597 12.44 4.28685 13.0909 5.09046 13.0909H10.1815C10.5831 13.0909 10.9089 12.7651 10.9089 12.3635C10.9089 11.962 10.5831 11.6362 10.1815 11.6362H5.09046V10.0572C5.93764 9.75748 6.54495 8.9488 6.54495 7.99981C6.54495 6.79543 5.56748 5.81796 4.36309 5.81796C3.15871 5.81796 2.18123 6.79543 2.18123 7.99981C2.18123 8.94905 2.78855 9.75771 3.63572 10.0572L3.63597 10.0575ZM15.2728 4.23929V9.45455C15.2728 9.8561 15.5986 10.1819 16.0001 10.1819C16.4017 10.1819 16.7275 9.8561 16.7275 9.45455V4.23929C17.5747 3.93953 18.182 3.13084 18.182 2.18186C18.182 0.977472 17.2045 0 16.0001 0C14.7957 0 13.8183 0.977472 13.8183 2.18186C13.8183 3.13109 14.4256 3.93975 15.2728 4.23929ZM4.36347 7.27269C4.76501 7.27269 5.09083 7.59851 5.09083 8.00006C5.09083 8.40161 4.76501 8.72743 4.36347 8.72743C3.96192 8.72743 3.6361 8.40161 3.6361 8.00006C3.6361 7.59851 3.96192 7.27269 4.36347 7.27269ZM27.6364 7.27269C28.038 7.27269 28.3638 7.59851 28.3638 8.00006C28.3638 8.40161 28.038 8.72743 27.6364 8.72743C27.2349 8.72743 26.909 8.40161 26.909 8.00006C26.909 7.59851 27.2349 7.27269 27.6364 7.27269ZM15.9996 1.45449C16.4012 1.45449 16.727 1.78031 16.727 2.18186C16.727 2.58341 16.4012 2.90923 15.9996 2.90923C15.5981 2.90923 15.2723 2.58341 15.2723 2.18186C15.2723 1.78031 15.5981 1.45449 15.9996 1.45449Z"
      fill="white"
    />
  </svg>
);
export const MintInstantIcon = () => (
  <svg
    width={36}
    height={30}
    viewBox="0 0 36 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.8282 4.79247C28.6725 3.22132 26.074 2.37464 23.4064 2.37464C20.7388 2.37464 18.1403 3.22132 15.9846 4.79247C15.5462 5.11255 15.1294 5.46128 14.7368 5.83656C11.5752 4.26594 7.82583 4.44189 4.826 6.3018C1.82534 8.1617 0 11.4409 0 14.9708C0 18.5009 1.82534 21.7802 4.826 23.6398C7.82638 25.4997 11.5754 25.6757 14.7368 24.1053C15.1637 24.5151 15.621 24.892 16.1046 25.2332C18.2374 26.7497 20.7894 27.5645 23.4064 27.5645C26.0234 27.5645 28.5752 26.7497 30.7082 25.2332C32.8844 23.6837 34.5118 21.4829 35.3552 18.948C36.1989 16.4131 36.215 13.6761 35.4013 11.1313C34.5873 8.58683 32.9858 6.36695 30.8282 4.79202L30.8282 4.79247ZM1.20761 14.9919C1.20922 11.9466 2.75094 9.10874 5.30453 7.44947C7.8584 5.79075 11.0779 5.53575 13.8611 6.7721C12.0033 8.93143 10.9277 11.6538 10.8072 14.4997L9.46309 12.8198C9.35274 12.6797 9.18561 12.5964 9.00723 12.5918C8.8184 12.5967 8.6427 12.6899 8.53314 12.8439L7.70526 14.0438L5.30539 11.044C5.19102 10.8833 5.00487 10.789 4.80747 10.7919C4.61864 10.7968 4.44294 10.89 4.33339 11.044L1.20766 15.4296V14.9917L1.20761 14.9919ZM10.2071 23.9914C8.19912 23.9887 6.24946 23.3149 4.66891 22.0766C3.08808 20.8381 1.96693 19.1068 1.48346 17.1577L4.83738 12.388L9.13918 17.7877L10.075 17.0436L8.46715 14.9919L9.03712 14.182L10.9029 16.5098C11.2034 18.9874 12.233 21.32 13.861 23.2115C12.7114 23.7255 11.4662 23.9911 10.2071 23.9914ZM30.006 24.2794C27.7214 25.9017 24.9194 26.6254 22.1352 26.3131C19.3507 26.0005 16.7789 24.6733 14.9109 22.5853C13.0427 20.4969 12.0091 17.7938 12.0072 14.9921C12.0077 13.1964 12.4322 11.4263 13.2467 9.8259C14.061 8.22554 15.2416 6.83999 16.6928 5.78254C18.6429 4.36133 20.9936 3.59585 23.4065 3.59585C25.8195 3.59585 28.1701 4.36133 30.1203 5.78254C32.0729 7.20799 33.5218 9.21709 34.2576 11.52C34.9937 13.8229 34.9784 16.2999 34.2143 18.5934C33.4499 20.8872 31.9764 22.8784 30.0062 24.2795L30.006 24.2794Z"
      fill="white"
    />
    <path
      d="M32.1056 27.2011L31.4097 26.2291C29.0726 27.8932 26.2749 28.7873 23.4058 28.7873C20.5368 28.7873 17.7393 27.8932 15.4019 26.2291L14.7061 27.2011C17.2439 29.0157 20.2858 29.9912 23.406 29.9912C26.5262 29.9912 29.5677 29.0157 32.1059 27.2011H32.1056Z"
      fill="white"
    />
    <path
      d="M15.2949 3.8387C17.6478 2.12506 20.4835 1.20179 23.3941 1.20179C26.3046 1.20179 29.1409 2.12506 31.4933 3.8387L32.2012 2.86668V2.86695C29.6382 1.00356 26.5508 0 23.382 0C20.2131 0 17.1257 1.00363 14.5628 2.86695L15.2949 3.8387Z"
      fill="white"
    />
    <path
      d="M9.00719 11.3921C9.48448 11.3921 9.94252 11.2025 10.2799 10.865C10.6174 10.5275 10.8071 10.0695 10.8071 9.59225C10.8071 9.11502 10.6174 8.65692 10.2799 8.3195C9.94246 7.98207 9.48442 7.79238 9.00719 7.79238C8.52996 7.79238 8.07186 7.98201 7.73444 8.3195C7.39701 8.65698 7.20732 9.11502 7.20732 9.59225C7.20732 10.0695 7.39695 10.5276 7.73444 10.865C8.07192 11.2024 8.52996 11.3921 9.00719 11.3921ZM9.00719 8.99225C9.24986 8.99225 9.46868 9.13849 9.56135 9.36267C9.6543 9.58685 9.60314 9.84478 9.43145 10.0165C9.25977 10.1882 9.00183 10.2393 8.77764 10.1464C8.55346 10.0537 8.40722 9.83487 8.40722 9.59221C8.40722 9.26089 8.67587 8.99225 9.00719 8.99225Z"
      fill="white"
    />
    <path
      d="M23.4064 7.19235C21.3379 7.19235 19.3539 8.01406 17.8912 9.47675C16.4285 10.9394 15.6068 12.9234 15.6068 14.9919C15.6068 17.0605 16.4285 19.0444 17.8912 20.5071C19.3539 21.9698 21.3379 22.7915 23.4064 22.7915C25.475 22.7915 27.4589 21.9698 28.9216 20.5071C30.3843 19.0444 31.206 17.0605 31.206 14.9919C31.206 12.9234 30.3843 10.9394 28.9216 9.47675C27.4589 8.01406 25.475 7.19235 23.4064 7.19235ZM23.4064 21.5916C22.0787 21.5908 20.7821 21.1895 19.6861 20.4401C18.5901 19.6909 17.7455 18.6287 17.2626 17.3918H18.3605L19.9804 19.0176H19.9807C20.0937 19.1301 20.2472 19.1925 20.4066 19.1917H21.7144C21.9046 19.7298 22.3388 20.1458 22.8846 20.3129C23.4304 20.4798 24.0229 20.3783 24.4817 20.0389C24.9405 19.6993 25.2114 19.1626 25.2114 18.5918C25.2114 18.021 24.9406 17.4843 24.4817 17.1447C24.0229 16.8053 23.4305 16.7038 22.8846 16.8707C22.3387 17.0378 21.9045 17.4538 21.7144 17.9919H20.6524L19.0325 16.3661C18.9195 16.2536 18.766 16.1912 18.6067 16.192H16.9209C16.7687 15.3992 16.7687 14.5849 16.9209 13.7921H18.6067C18.766 13.7929 18.9195 13.7305 19.0325 13.618L20.6524 11.9922H21.7144C21.9046 12.5303 22.3388 12.9463 22.8846 13.1134C23.4304 13.2803 24.0229 13.1788 24.4817 12.8394C24.9405 12.4998 25.2114 11.9631 25.2114 11.3923C25.2114 10.8215 24.9406 10.2848 24.4817 9.94518C24.0229 9.60582 23.4305 9.50431 22.8846 9.67117C22.3387 9.83831 21.9045 10.2543 21.7144 10.7924H20.4066C20.2472 10.7916 20.0937 10.854 19.9807 10.9665L18.3608 12.5923H17.2626C17.8478 11.0932 18.9605 9.85974 20.3913 9.12374C21.8223 8.38746 23.4728 8.19944 25.0327 8.59502C26.5923 8.99035 27.9538 9.94223 28.8612 11.2713C29.7684 12.6001 30.1589 14.2149 29.9591 15.8115C29.7593 17.4084 28.9831 18.8769 27.7762 19.9413C26.5696 21.006 25.0155 21.5928 23.4064 21.5917L23.4064 21.5916ZM22.8064 18.5917C22.8064 18.3491 22.9527 18.1302 23.1769 18.0376C23.401 17.9446 23.659 17.9958 23.8307 18.1675C24.0024 18.3391 24.0535 18.5971 23.9606 18.8213C23.8679 19.0455 23.6491 19.1917 23.4064 19.1917C23.0751 19.1917 22.8064 18.923 22.8064 18.5917ZM22.8064 11.3921C22.8064 11.1495 22.9527 10.9306 23.1769 10.838C23.401 10.745 23.659 10.7962 23.8307 10.9679C24.0024 11.1395 24.0535 11.3975 23.9606 11.6217C23.8679 11.8458 23.6491 11.9921 23.4064 11.9921C23.0751 11.9921 22.8064 11.7234 22.8064 11.3921Z"
      fill="white"
    />
    <path d="M22.8064 4.79248H24.0064V5.99241H22.8064V4.79248Z" fill="white" />
    <path d="M22.8064 23.9914H24.0064V25.1914H22.8064V23.9914Z" fill="white" />
    <path d="M32.4059 14.392H33.6058V15.5919H32.4059V14.392Z" fill="white" />
    <path d="M13.207 14.392H14.4069V15.5919H13.207V14.392Z" fill="white" />
    <path
      d="M29.3464 8.20784L30.1947 7.35931L31.0432 8.20756L30.1949 9.05609L29.3464 8.20784Z"
      fill="white"
    />
    <path
      d="M15.7728 21.7787L16.621 20.9302L17.4695 21.7785L16.6213 22.627L15.7728 21.7787Z"
      fill="white"
    />
    <path
      d="M29.3457 21.7815L30.1943 20.933L31.0428 21.7815L30.1943 22.63L29.3457 21.7815Z"
      fill="white"
    />
    <path
      d="M15.7748 8.20372L16.6234 7.35519L17.4719 8.20372L16.6234 9.05224L15.7748 8.20372Z"
      fill="white"
    />
    <path
      d="M24.0962 14.392H19.2065V15.5919H24.0904C24.2867 16.3526 24.843 16.9689 25.5793 17.242C26.3159 17.5152 27.1395 17.4105 27.7845 16.9619C28.4294 16.5132 28.8138 15.7775 28.8138 14.9919C28.8138 14.2063 28.4294 13.4705 27.7845 13.022C27.1395 12.5734 26.3159 12.4686 25.5793 12.7418C24.843 13.015 24.2867 13.6313 24.0904 14.392L24.0962 14.392ZM27.606 14.9919C27.606 15.3101 27.4796 15.6155 27.2546 15.8404C27.0296 16.0654 26.7243 16.1919 26.4061 16.1919C26.0879 16.1919 25.7826 16.0654 25.5576 15.8404C25.3326 15.6155 25.2062 15.3101 25.2062 14.9919C25.2062 14.6737 25.3326 14.3684 25.5576 14.1434C25.7826 13.9184 26.0879 13.792 26.4061 13.792C26.7243 13.792 27.0296 13.9184 27.2546 14.1434C27.4796 14.3684 27.606 14.6737 27.606 14.9919Z"
      fill="white"
    />
  </svg>
);
export const AngleRight = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.219901 13.1764C0.382021 13.3511 0.602262 13.4396 0.823175 13.4395C1.0235 13.4395 1.22431 13.3668 1.38269 13.2197L7.73682 7.32281C7.90465 7.16706 8 6.94862 8 6.71971C8 6.4908 7.90466 6.27221 7.73682 6.1166L1.38269 0.219712C1.04963 -0.0893427 0.528978 -0.0700793 0.219776 0.263142C-0.0894416 0.5962 -0.0700155 1.11685 0.263205 1.42605L5.96742 6.71984L0.263205 12.0136C-0.0700155 12.3227 -0.0894416 12.8433 0.219776 13.1765L0.219901 13.1764Z"
      fill="white"
    />
  </svg>
);
export const ReloadIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.17231 12.1614C1.45589 12.6152 2.04219 12.7665 2.51491 12.5017C2.98764 12.2181 3.12007 11.6129 2.83635 11.1402C2.17447 10.0623 1.85305 8.77659 1.98548 7.39624C2.26906 4.48432 4.67055 2.17736 7.58254 1.96936C11.1185 1.7235 14.0683 4.55986 14.0305 8.03914C13.9926 11.2726 11.3454 13.9577 8.11199 14.0144H8.07413V12.5773C8.07413 12.1613 7.62028 11.8966 7.26111 12.1235L3.38477 14.5627C3.04448 14.7707 3.04448 15.2623 3.38477 15.4703L7.24221 17.8908C7.60151 18.1176 8.05522 17.8529 8.05522 17.4369V15.9809C12.6501 15.943 16.3184 12.0478 15.9781 7.37729C15.6755 3.48205 12.5177 0.324246 8.60358 0.0217029C3.93307 -0.318591 0 3.3875 0 8.00129C0 9.51404 0.434872 10.9511 1.17232 12.1613L1.17231 12.1614Z"
      fill="white"
    />
  </svg>
);
export const GoBack = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.14475 5.77031L11.0981 5.77031V4.12171L3.14475 4.12171L6.10628 1.17544L4.94612 -4.1008e-05L5.53131e-05 4.94602L4.94612 9.89209L6.10628 8.71661L3.14475 5.77031Z"
      fill="white"
    />
  </svg>
);
export const UploadIcon = () => (
  <svg
    width={11}
    height={14}
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15346 13.5685H1.8465C1.35716 13.5679 0.888176 13.3733 0.542248 13.0274C0.19632 12.6814 0.00171563 12.2124 0.0010902 11.7231V8.97157C-0.010759 8.73618 0.0743847 8.50628 0.236851 8.33538C0.399195 8.1646 0.624558 8.06786 0.860347 8.06786C1.09599 8.06786 1.32136 8.1646 1.48372 8.33538C1.64618 8.50627 1.73133 8.73616 1.71948 8.97157V11.7231C1.71948 11.7932 1.77628 11.8502 1.84652 11.8502H9.15348C9.22372 11.8502 9.28052 11.7932 9.28052 11.7231V8.97157C9.26867 8.73618 9.35382 8.50628 9.51628 8.33538C9.67863 8.1646 9.90399 8.06786 10.1397 8.06786C10.3754 8.06786 10.6008 8.1646 10.7632 8.33538C10.9256 8.50627 11.0108 8.73616 10.9989 8.97157V11.7231C10.9983 12.2124 10.8037 12.6814 10.4578 13.0274C10.1118 13.3733 9.64284 13.5679 9.1535 13.5685H9.15346Z"
      fill="black"
    />
    <path
      d="M5.39249 9.27365C5.16467 9.27365 4.94624 9.18326 4.78488 9.0225C4.62363 8.86163 4.53275 8.64333 4.53214 8.41552V2.92764L2.79193 4.67886C2.63117 4.84071 2.41251 4.93172 2.18444 4.93172C1.95638 4.93172 1.73773 4.84071 1.57696 4.67886C1.41584 4.51822 1.3252 4.30006 1.3252 4.07246C1.3252 3.84487 1.41583 3.62672 1.57696 3.46607L4.78388 0.246021C4.9472 0.0881957 5.16536 0 5.39246 0C5.61954 0 5.8377 0.0881957 6.00104 0.246021L9.20577 3.45513C9.36603 3.61637 9.45594 3.83455 9.4557 4.06199C9.45557 4.28932 9.36542 4.50749 9.20491 4.6686C9.04452 4.8296 8.82671 4.92073 8.5994 4.92171C8.37072 4.92195 8.15146 4.83045 7.99082 4.66774L6.2396 2.92753V8.41542C6.23899 8.64104 6.14994 8.85725 5.9915 9.01777C5.83307 9.17828 5.61796 9.27014 5.39246 9.27357L5.39249 9.27365Z"
      fill="black"
    />
  </svg>
);
export const Check = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8862 0.215071C10.3546 -0.164701 9.62039 -0.0254594 9.24062 0.50619L4.69628 6.99991L2.01272 4.31635C1.55702 3.86065 0.797474 3.86065 0.341775 4.31635C-0.113925 4.77204 -0.113925 5.53159 0.341775 5.98729L4.01269 9.6582C4.24049 9.88601 4.54434 10 4.84816 10H4.86079H4.97469C5.30378 9.97466 5.62024 9.79745 5.83541 9.50633L11.1899 1.8607C11.5572 1.31625 11.418 0.582072 10.8863 0.215004L10.8862 0.215071Z"
      fill="white"
    />
  </svg>
);
export const Basic = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1486 2.81727L15.4629 0.123C15.1818 -0.0410001 14.8304 -0.0410001 14.5258 0.123L9.84003 2.81727C9.55889 2.98127 9.37146 3.28584 9.37146 3.63724V9.02557C9.37146 9.35357 9.55889 9.68157 9.84003 9.84554L14.5258 12.5398C14.8069 12.7038 15.1583 12.7038 15.4629 12.5398L20.1486 9.84554C20.4298 9.68154 20.6172 9.37697 20.6172 9.02557V3.63724C20.6172 3.30924 20.4298 2.98124 20.1486 2.81727Z"
      fill="#4D505B"
    />
    <path
      d="M20.1486 20.1544L15.4629 17.4602C15.1818 17.2962 14.8304 17.2962 14.5258 17.4602L9.84003 20.1544C9.55889 20.3184 9.37146 20.623 9.37146 20.9744V26.3627C9.37146 26.6907 9.55889 27.0187 9.84003 27.1827L14.5258 29.877C14.8069 30.041 15.1583 30.041 15.4629 29.877L20.1486 27.1827C20.4298 27.0187 20.6172 26.7141 20.6172 26.3627V20.9744C20.6172 20.6464 20.4298 20.3184 20.1486 20.1544Z"
      fill="#4D505B"
    />
    <path
      d="M29.5201 11.4862L24.8344 8.79195C24.5532 8.62795 24.2018 8.62795 23.8972 8.79195L19.2115 11.4862C18.9303 11.6502 18.7429 11.9548 18.7429 12.3062V17.6945C18.7429 18.0225 18.9303 18.3505 19.2115 18.5145L23.8972 21.2088C24.1784 21.3728 24.5298 21.3728 24.8344 21.2088L29.5201 18.5145C29.8012 18.3505 29.9887 18.0459 29.9887 17.6945V12.3062C29.9887 11.9782 29.8012 11.6502 29.5201 11.4862Z"
      fill="#4D505B"
    />
    <path
      d="M10.7772 11.4862L6.09145 8.79195C5.8103 8.62795 5.4589 8.62795 5.1543 8.79195L0.468573 11.4862C0.187429 11.6502 0 11.9548 0 12.3062V17.6945C0 18.0225 0.187429 18.3505 0.468573 18.5145L5.1543 21.2088C5.43545 21.3728 5.78685 21.3728 6.09145 21.2088L10.7772 18.5145C11.0583 18.3505 11.2458 18.0459 11.2458 17.6945V12.3062C11.2458 11.9782 11.0583 11.6502 10.7772 11.4862Z"
      fill="#4D505B"
    />
  </svg>
);
export const Standard = () => (
  <svg
    width="26"
    height="30"
    viewBox="0 0 26 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.27185 29.8051C5.29507 25.669 6.32909 23.2968 7.87999 21.0766C9.55279 18.6435 9.97846 16.2105 9.97846 16.2105C9.97846 16.2105 11.286 17.9135 10.7691 20.5899C13.0805 18.0047 13.5368 13.8991 13.1716 12.3175C18.4332 15.9672 20.6837 23.9048 17.6425 29.8047C33.7307 20.7115 21.6265 7.08606 19.528 5.56559C20.2274 7.08634 20.3491 9.70168 18.9501 10.9487C16.5781 1.85493 10.6474 0 10.6474 0C11.3468 4.68344 8.09288 9.82314 4.99075 13.6551C4.86929 11.8 4.77782 10.4922 3.77443 8.69774C3.53107 12.104 0.945918 14.8715 0.246466 18.2475C-0.69652 22.8701 0.945861 26.2459 7.2718 29.8046L7.27185 29.8051Z"
      fill="#2A73E2"
    />
  </svg>
);
export const Premium = () => (
  <svg
    width="32"
    height="21"
    viewBox="0 0 32 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.2627 18.0078H2.2511V20.8215H29.2627V18.0078ZM29.3353 16.8823H2.17836L0 0L6.75291 9.56662L15.7568 0L24.7607 9.56662L31.5136 0L29.3353 16.8823Z"
      fill="#73E9ED"
    />
  </svg>
);
export const CheckeIcon = () => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1666 0C8.59472 0 0 8.59472 0 19.1666C0 29.7385 8.59472 38.3333 19.1666 38.3333C29.7385 38.3333 38.3333 29.7385 38.3333 19.1666C38.3333 8.59472 29.7385 0 19.1666 0ZM28.8508 15.2122L17.2701 26.7929C16.9473 27.1158 16.4226 27.1158 16.1403 26.7929L9.48258 20.1352C9.15974 19.8123 9.15974 19.2877 9.48258 19.0054L12.0248 16.4632C12.3476 16.1404 12.8723 16.1404 13.1546 16.4632L16.7055 20.0141L25.1792 11.5405C25.502 11.2176 26.0267 11.2176 26.309 11.5405L28.8512 14.0826C29.1735 14.4055 29.1735 14.8896 28.8506 15.2125L28.8508 15.2122Z"
      fill="#73E9ED"
    />
  </svg>
);
export const DownloadIcon = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.65539 0.000365496C8.37549 0.000365496 8.10705 0.11162 7.90898 0.309535C7.71106 0.507451 7.59981 0.775914 7.59981 1.05595V12.2444L2.59222 7.86182C2.38526 7.65613 2.10239 7.54544 1.81073 7.5559C1.51924 7.56636 1.24498 7.69698 1.05314 7.91695C0.861301 8.13678 0.769129 8.42629 0.798251 8.71653C0.827514 9.0069 0.975664 9.27212 1.20738 9.44937L6.84829 14.3893C7.3493 14.8253 7.99124 15.0655 8.65539 15.0655C9.31955 15.0655 9.96148 14.8253 10.4625 14.3893L16.1034 9.44937C16.3197 9.2598 16.4492 8.9902 16.4621 8.70281C16.4749 8.41556 16.3702 8.1355 16.1717 7.92727C15.9734 7.71917 15.6985 7.60085 15.411 7.6C15.1558 7.59929 14.9093 7.69246 14.7186 7.86181L9.71097 12.2444V1.05559C9.71097 0.775538 9.59972 0.507092 9.4018 0.30917C9.20374 0.111255 8.93528 0 8.65539 0L8.65539 0.000365496Z"
      fill="white"
    />
    <path
      d="M0 17.9445C0 18.2245 0.111255 18.493 0.30917 18.6909C0.507226 18.8888 0.775693 19.0001 1.05559 19.0001H16.2553C16.6325 19.0001 16.981 18.7989 17.1694 18.4723C17.358 18.1456 17.358 17.7433 17.1694 17.4168C16.981 17.0902 16.6325 16.889 16.2553 16.889H1.05559C0.775679 16.889 0.507237 17.0002 0.30917 17.1982C0.111255 17.3961 0 17.6646 0 17.9445Z"
      fill="white"
    />
  </svg>
);
export const Invoice = () => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9998 1.96014C15.0046 1.64457 14.9166 1.33452 14.7465 1.0686C14.5764 0.802683 14.3318 0.592779 14.0431 0.465038C13.7615 0.332891 13.4475 0.28525 13.1394 0.328044C12.8311 0.370838 12.542 0.502179 12.3069 0.706202C12.1944 0.80269 12.0818 0.907115 11.9693 1.01975V1.01962C11.7047 1.37287 11.2932 1.58601 10.8519 1.59841C10.414 1.58899 10.0049 1.37853 9.74266 1.02771C9.18674 0.375574 8.37299 0 7.51605 0C6.6591 0 5.84536 0.375574 5.28944 1.02771C5.02312 1.37786 4.61187 1.58794 4.17208 1.59841C3.73419 1.58899 3.32496 1.37853 3.06283 1.02771L2.69304 0.706226C2.45875 0.503832 2.17105 0.373432 1.86448 0.330789C1.55793 0.287996 1.24545 0.334558 0.964749 0.465089C0.674748 0.591587 0.428361 0.800977 0.256765 1.06704C0.0851869 1.33295 -0.004032 1.64366 0.000139897 1.96019V15.7058C-0.00403166 16.0223 0.0851903 16.333 0.256765 16.5989C0.428344 16.865 0.674748 17.0744 0.964749 17.2009C1.24546 17.3314 1.55794 17.378 1.86448 17.3352C2.17103 17.2925 2.45874 17.1621 2.69304 16.9597C2.80554 16.8632 2.91818 16.7588 3.03068 16.6462V16.6463C3.29793 16.2835 3.72143 16.0687 4.17211 16.0675C4.6119 16.078 5.02313 16.2881 5.28946 16.6382C5.84538 17.2903 6.65913 17.6659 7.51607 17.6659C8.37302 17.6659 9.18676 17.2903 9.74268 16.6382C10.005 16.2874 10.414 16.0769 10.8519 16.0675C11.2919 16.078 11.703 16.2881 11.9693 16.6382C12.0818 16.7507 12.1944 16.8553 12.3069 16.9518C12.542 17.1556 12.8311 17.287 13.1394 17.3298C13.4475 17.3726 13.7615 17.3251 14.0431 17.1929C14.3318 17.0651 14.5764 16.8551 14.7465 16.5893C14.9166 16.3235 15.0047 16.0133 14.9998 15.6977L14.9998 1.96014ZM13.3921 15.7377L13.1188 15.4885C12.5599 14.8414 11.7472 14.4694 10.8921 14.4694C10.0371 14.4694 9.22442 14.8414 8.66553 15.4885C8.26357 15.8824 8.04664 16.0673 7.55628 16.0673C7.06591 16.0673 6.84885 15.8824 6.43892 15.4885C5.88004 14.8414 5.06726 14.4694 4.21231 14.4694C3.35726 14.4694 2.54445 14.8414 1.98557 15.4885C1.90132 15.5829 1.79703 15.657 1.68022 15.7056V1.92797L1.94546 2.1772C2.50435 2.82434 3.31699 3.1963 4.17207 3.1963C5.02712 3.1963 5.8398 2.82434 6.39868 2.1772C6.80857 1.7833 7.02564 1.5984 7.51604 1.5984C8.00643 1.5984 8.22347 1.7833 8.62529 2.1772C9.18418 2.82434 9.99696 3.1963 10.8519 3.1963C11.707 3.1963 12.5198 2.82434 13.0785 2.1772C13.1699 2.08435 13.2726 2.00333 13.384 1.93605L13.3921 15.7377Z"
      fill="white"
    />
    <path
      d="M10.7309 6.01929H4.30041C4.01323 6.01929 3.74786 6.17256 3.60427 6.42125C3.46069 6.66994 3.46069 6.97634 3.60427 7.22504C3.74786 7.47373 4.01323 7.627 4.30041 7.627H10.7312H10.7311C11.0182 7.627 11.2836 7.47373 11.4272 7.22504C11.5708 6.97635 11.5708 6.66995 11.4272 6.42125C11.2836 6.17256 11.0182 6.01929 10.7311 6.01929H10.7309Z"
      fill="white"
    />
    <path
      d="M9.92713 10.0386H4.30041C4.01323 10.0386 3.74786 10.1918 3.60427 10.4405C3.46069 10.6892 3.46069 10.9956 3.60427 11.2443C3.74786 11.493 4.01323 11.6463 4.30041 11.6463H9.92713C10.2143 11.6463 10.4797 11.493 10.6233 11.2443C10.7669 10.9956 10.7669 10.6892 10.6233 10.4405C10.4797 10.1918 10.2143 10.0386 9.92713 10.0386Z"
      fill="white"
    />
  </svg>
);
export const AngleLeft = () => (
  <svg
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.00123011 8.53992C0.0126734 8.88657 0.150979 9.21683 0.390107 9.46801L7.17847 16.5392C7.52907 16.904 8.04757 17.054 8.53867 16.9328C9.02975 16.8117 9.41904 16.4376 9.5597 15.9517C9.70018 15.4657 9.57095 14.9417 9.22034 14.5769L3.3775 8.48703L9.22034 2.3972C9.57095 2.03239 9.70018 1.50835 9.5597 1.02241C9.41903 0.536459 9.02977 0.162599 8.53867 0.0412265C8.04759 -0.0799135 7.5291 0.0702295 7.17847 0.43484L0.390107 7.50605C0.125528 7.78385 -0.0147508 8.15716 0.00123011 8.54032V8.53992Z"
      fill="#313338"
    />
  </svg>
);
export const AngleRight2 = () => (
  <svg
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.614 8.43421C9.60256 8.08755 9.46426 7.75729 9.22513 7.50611L2.43676 0.434895C2.08616 0.0700855 1.56766 -0.0798397 1.07656 0.0412807C0.585484 0.16242 0.196198 0.536503 0.0555315 1.02246C-0.0849438 1.50841 0.0442858 2.03243 0.39489 2.39726L6.23773 8.48709L0.39489 14.5769C0.0442886 14.9417 -0.0849438 15.4658 0.0555315 15.9517C0.196208 16.4377 0.585468 16.8115 1.07656 16.9329C1.56764 17.054 2.08613 16.9039 2.43676 16.5393L9.22513 9.46807C9.48971 9.19027 9.62999 8.81696 9.614 8.4338V8.43421Z"
      fill="white"
    />
  </svg>
);
export const Bar = () => (
  <svg width={30} viewBox="0 0 31 30" fill="none">
    <g clipPath="url(#clip0_3_218)">
      <path
        d="M22.8193 22.5V25H7.81934V22.5H22.8193ZM26.5693 13.75V16.25H4.06934V13.75H26.5693ZM22.8193 5V7.5H7.81934V5H22.8193Z"
        fill="var(--dark)"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_218">
        <rect
          width={30}
          height={30}
          fill="var(--dark)"
          transform="translate(0.319336)"
        />
      </clipPath>
    </defs>
  </svg>
);
